import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login.page";
import HomePage from "./pages/home.page";
import Layout from "./components/Layout";
import UserPage from "./pages/users/user.page";
import UserCreatePage from "./pages/users/user.create.page";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import UserEditPage from "./pages/users/user.edit.page";
import SocietiesPage from "./pages/societies/societies.page";
import ClientPage from "./pages/clients/client.page";
import SettingsPage from "./pages/settings/settings.page";
import ProductPage from "./pages/products/product.page";
import SocietyCreatePage from "./pages/societies/society.create.page";
import RecoverPasswordPage from "./pages/recover-password/recover-password.page";
import LogPage from "./pages/logs/log.page";
import SocietyEditPage from "./pages/societies/society.edit.page";
import ChangePasswordPage from "./pages/change-password/change-password-page";
import StocksPage from "./pages/stocks/stocks.page";
import StockCreatePage from "./pages/stocks/stock.create.page";
import StockViewPage from "./pages/stocks/stock.view.page";
import StockEditPage from "./pages/stocks/stock.edit.page";
import StockArribalPage from "./pages/stocks/stock.arribal.page";
import OrdersPage from "./pages/orders/orders.page";
import TangoOrdersPage from "./pages/orders/orders.tango.page";
import TangoOrderDetailsPage from "./pages/orders/order.tango.details.page";
import OrderCreatePage from "./pages/orders/order.create.page";
import ReportsPage from "./pages/reports/reports";
import CartPage from "./pages/orders/cart/cart.page";
import CuposLayout from "./pages/cupos/cupos.layout";
import CuposProductoPage from "./pages/cupos/cupos.producto.page";
import CuposProductoCreatePage from "./pages/cupos/cupos.producto.create.page";
import CuposClientePage from "./pages/cupos/cupos.cliente.page";
import CuposClienteCreatePage from "./pages/cupos/cupos.cliente.create.page";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />

      {/* Public routes - redirect to home if already logged in */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/recover-password" element={<RecoverPasswordPage />} />
      </Route>

      {/* Protected routes - require authentication */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Layout />}>
          <Route path="home" element={<HomePage />} />
          <Route path="users" element={<UserPage />} />
          <Route path="users/create" element={<UserCreatePage />} />
          <Route path="users/edit/:id" element={<UserEditPage />} />
          <Route path="societies" element={<SocietiesPage />} />
          <Route path="societies/create" element={<SocietyCreatePage />} />
          <Route path="societies/edit/:id" element={<SocietyEditPage />} />
          <Route path="clients" element={<ClientPage />} />
          <Route path="products" element={<ProductPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="logs" element={<LogPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="stock" element={<StocksPage />} />
          <Route path="stocks/create" element={<StockCreatePage />} />
          <Route path="stocks/view/:id" element={<StockViewPage />} />
          <Route path="stocks/edit/:id" element={<StockEditPage />} />
          <Route path="stocks/arribal/:id" element={<StockArribalPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/tango" element={<TangoOrdersPage />} />
          <Route path="orders/tango/:orderId" element={<TangoOrderDetailsPage />} />
          <Route path="orders/create" element={<OrderCreatePage />} />
          <Route path="orders/cart" element={<CartPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="cupos" element={<CuposLayout />}>
            <Route index element={<Navigate to="producto" replace />} />
            <Route
              path="producto/crear"
              element={<CuposProductoCreatePage />}
            />
            <Route path="producto" element={<CuposProductoPage />} />
            <Route path="cliente/crear" element={<CuposClienteCreatePage />} />
            <Route path="cliente" element={<CuposClientePage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
